import { css } from "@emotion/css";
import React from "react";

import { RequirementsItem } from "./RequirementsItem";
import {
  RequirementsItem as RequirementsItemType,
  RequirementsListProps,
} from "./types";

export function RequirementsList({
  requirementsList,
  testID = "requirements-list",
}: RequirementsListProps) {
  if (requirementsList.length === 0) {
    return null;
  }
  return (
    <ul className={css({ padding: 0, margin: 0 })} data-testid={testID}>
      {requirementsList.map((requirementsItem: RequirementsItemType, index) => (
        <RequirementsItem key={index} requirementsItem={requirementsItem} />
      ))}
    </ul>
  );
}
